import documentation from "./documentation.png";
import money_symbol from "./money_symbol.png";
import hard_work from "./hard_work.png";
import technical from "./technical.png";
import calendar from "./calendar-days.svg";
import provider from "./provider.png";
import quality from "./quality.png";
import pause from "./pause.png";

export const OVERTIME_ICONS = {
	money_symbol,
	quality,
	calendar,
	documentation,
	hard_work,
	pause,
	provider,
	technical,
};
